var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTripleDot = function SvgTripleDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#807D7D",
    strokeWidth: 1.5,
    d: "M20.5 5.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8.5 11.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM21.5 18.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#807D7D",
    strokeWidth: 1.5,
    d: "M14.535 4.581a8 8 0 0 0-1.162-.081 8.15 8.15 0 0 0-7.132 4.163m13.472-1.168A7.9 7.9 0 0 1 21.5 12.5c0 1.376-.353 2.67-.974 3.801m-4.644 3.81a8.2 8.2 0 0 1-2.509.389c-3.79 0-6.974-2.555-7.873-6.01"
  })));
};
export default SvgTripleDot;